import EmptyState from "@galaxy-io/dls/feedback/EmptyState";
import type { Icon as PhosphorIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { LoadingLayout } from "@/components/loading-layout";

export function SignalPlaceholder({
  icon,
  heading,
  message,
  children,
}: {
  icon: PhosphorIcon;
  heading?: string;
  message: string;
  children?: ReactNode;
}) {
  return (
    <EmptyState
      role="status"
      icon={icon}
      header={heading || message}
      description={heading ? message : undefined}
      actions={children}
    />
  );
}
export function SignalLoading({ message = "Loading signals…" }: { message?: string }) {
  return <LoadingLayout message={message} />;
}
